import type { Deck } from './types'
import { aiSlopPreventionMain } from './ai-slop-prevention/main'

const allDecks: Deck[] = [
  aiSlopPreventionMain,
]

export function getDecksByWorkshop(workshopSlug: string): Deck[] {
  return allDecks.filter(d => d.workshopSlug === workshopSlug)
}

export function getDeck(workshopSlug: string, type: string): Deck | undefined {
  return allDecks.find(d => d.workshopSlug === workshopSlug && d.type === type)
}

export function getDeckById(id: string): Deck | undefined {
  return allDecks.find(d => d.id === id)
}

export { allDecks }
export type { Deck, Slide, DeckType, WorkshopAccessResult } from './types'
